import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { connectRouter, RouterState } from 'connected-react-router';
import { History } from 'history';

import pageSaga from './page/sagas';
import { PageState } from './page/types';
import { pageReducer } from './page/reducer';

import configSaga from './config/sagas';
import { ConfigState } from './config/types';
import { configReducer } from './config/reducer';

export interface ApplicationState {
  router: RouterState;
  page: PageState;
  config: ConfigState;
}

export const createRootReducer = (history: History) => combineReducers({
  router: connectRouter(history),
  page: pageReducer,
  config: configReducer,
});

export function* rootSaga() {
  yield all([fork(configSaga), fork(pageSaga)]);
}
